import { Copyable } from '@components'

import { Flex, Space, Spacing, Text } from '@billy/design-system'
import { FC, PropsWithChildren } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import * as Styled from './styles'

interface CodeProps {
  text?: string | null
}

const Code = ({ text }: CodeProps) => {
  if (!text) {
    return null
  }

  return (
    <Styled.CodeTag>
      {/* style for font-family needs to inherit from CodeTag */}
      <Copyable renderAs="text" valueToCopy={text} style={{ fontFamily: 'inherit' }}>
        {text}
      </Copyable>
    </Styled.CodeTag>
  )
}

const InformationTag: FC<PropsWithChildren<{ name: string }>> = ({ name, children }) => {
  return (
    <Flex alignItems="center" flexDirection="row" gap={Spacing.S8}>
      <Text>{name}</Text>
      <Text>{children}</Text>
    </Flex>
  )
}

export const OrganizationInfo = () => {
  const { organization } = useUserOrganization()

  return (
    <div>
      <Space size="s24" />
      <Flex flexDirection="column" gap={Spacing.S8}>
        <InformationTag name="Org ID">
          <Code text={organization?.id} />
        </InformationTag>

        <InformationTag name="Global ID">
          <Code text={organization?.globalId} />
        </InformationTag>
      </Flex>
    </div>
  )
}
